<template>
	<ul class="dropdown-menu dropdown-menu-right">
		<li :class="{'child_menu': true}">
			<router-link :to="defaultProfileUrl">
				<md-icon class="profile_icons">person</md-icon>Profile
			</router-link>
		</li>
		<li :class="{'child_menu': true}" v-if="parentSession" @click="goBackToMainDashboard">
			<a href="javascript:void(0)">
				<md-icon class="profile_icons">keyboard_return</md-icon>Back to Main Panel
			</a>
		</li>
		<li :class="{'child_menu': true}" @click="logoutUser">
			<a href="javascript:void(0)"><md-icon class="profile_icons">exit_to_app</md-icon>Logout</a>
		</li>
	</ul>
</template>
<script>
import { hasParentSession, profileUrl } from "@/lib/utils";
export default {
	name: 'logout',
	data() {
		return {
			parentSession: hasParentSession(),
			defaultProfileUrl: profileUrl()
		};
	},
	methods: {
		async logoutUser() {
			await this.$logout(this);
		},
		async goBackToMainDashboard() {
      await this.$logout(this, '/consultant/login');
    }
	}
};
</script>
<style scoped>
.profile_icons {
	padding-right: 25px;
}
.profile_icons:hover {
	color: white !important;
}
</style>
